import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
import { HelperService } from '../../services/helper.service';
import { ExtLoopBackAuth } from 'src/app/shared/modules/ext-sdk/services/ext-sdk-auth.service';
export class VehicleDetailsTabSchedulesComponent extends ABaseComponent {
    constructor(logger, ui, dss, dialog, helperService, auth) {
        super(logger);
        this.logger = logger;
        this.ui = ui;
        this.dss = dss;
        this.dialog = dialog;
        this.helperService = helperService;
        this.auth = auth;
    }
    set vehicleService(v) {
        this._vehicleService = v;
        this.changeHandle();
    }
    get vehicleService() {
        return this._vehicleService;
    }
    changeHandle() { }
    onScheduleInserting(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                event.data.id = event.data.__KEY__;
                event.data.createdAt = new Date();
                const { id, username } = this.auth.getCurrentUserData();
                event.data.createdBy = { id, username };
                let { schedules } = this.vehicleService;
                schedules = [Object.assign({}, event.data, { __KEY__: undefined }), ...this.vehicleService.schedules];
                this.vehicleService.schedules = schedules; // Update the local state with predicted data
                // Call the API to add the new schedule
                const updatedVehicleService = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { schedules })
                    .toPromise();
                // Update the local state with the response
                this.vehicleService.schedules = updatedVehicleService.schedules;
            }
            catch (error) {
                notify('Error inserting schedule', 'error', 3000);
                console.error('Error inserting schedule:', error);
                event.cancel = true;
            }
        });
    }
    onScheduleUpdating(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const { schedules } = this.vehicleService;
                const index = schedules.findIndex((schedule) => schedule.id === event.key.id);
                if (index !== -1) {
                    schedules[index] = Object.assign({}, schedules[index], event.newData, { updatedAt: new Date() });
                    const { schedules: updatedSchedules } = yield this.dss
                        .getApi(VehicleService)
                        .mySaveWithRelated(this.vehicleService.id, { schedules })
                        .toPromise();
                    this.vehicleService.schedules = updatedSchedules;
                }
            }
            catch (error) {
                notify('Error updating schedule', 'error', 3000);
                console.error('Error updating schedule:', error);
                event.cancel = true;
            }
        });
    }
    onScheduleRemoving(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { schedules } = this.vehicleService;
            const index = schedules.findIndex((schedule) => schedule.id === event.key.id);
            if (index !== -1) {
                schedules.splice(index, 1);
                const { schedules: updatedSchedules } = yield this.dss
                    .getApi(VehicleService)
                    .mySaveWithRelated(this.vehicleService.id, { schedules })
                    .toPromise();
                this.vehicleService.schedules = updatedSchedules;
            }
        });
    }
}
